import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowRoundAntiClockwise20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconArrowRoundAntiClockwise20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.092 8.5c.817-2.677 3.493-4.17 6.221-3.44 2.79.748 4.37 3.484 3.622 6.276-.748 2.793-3.485 4.373-6.275 3.625a5.4 5.4 0 0 1-2.058-1.05 4.4 4.4 0 0 1-.589-.59l-.02-.029-.003-.003.002.003-.002-.002v-.001a.75.75 0 0 0-1.232.856l.617-.426-.616.427v.002l.003.002.005.008.014.02.048.062q.06.078.168.203c.146.165.36.385.647.623a6.9 6.9 0 0 0 2.628 1.344c3.591.962 7.15-1.093 8.112-4.685s-1.091-7.151-4.682-8.114C8.855 2.85 6.029 3.983 4.5 6.275V5A.75.75 0 1 0 3 5v5h4.985a.75.75 0 1 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowRoundAntiClockwise20);
